import React from "react";

const iconPaths = {
  partners: (
    <>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      <path d="M19 8h3M20.5 6.5v3" />
    </>
  ),
  company: (
    <>
      <path d="M4 21V9l8-5 8 5v12" />
      <path d="M9 21V12h6v9" />
      <path d="M4 9h16" />
    </>
  ),
  favorite: (
    <>
      <path
        d="M19.5 13.572 12 21.001 4.5 13.572a5.25 5.25 0 0 1 7.425-7.425L12 5.151l.075-.074a5.25 5.25 0 0 1 7.425 7.425Z"
      />
    </>
  ),
  employees: (
    <>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </>
  ),
  report: (
    <>
      <path d="M4 19V5" />
      <path d="M4 19h16" />
      <path d="M8 19v-6" />
      <path d="M12 19V9" />
      <path d="M16 19v-3" />
    </>
  ),
  admin: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path
        d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
      />
    </>
  ),
  profile: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M6 21v-1a6 6 0 0 1 12 0v1" />
    </>
  ),
  notes: (
    <>
      <path d="M8 2h8a2 2 0 0 1 2 2v16l-4-2-4 2-4-2-4 2V4a2 2 0 0 1 2-2z" />
      <path d="M9 6h6M9 10h6M9 14h4" />
    </>
  ),
};

export default function HeaderNavIcon({ name, active = false }) {
  const paths = iconPaths[name];
  if (!paths) {
    return null;
  }

  return (
    <span
      className={`header-nav-icon${active ? " header-nav-icon--active" : ""}`}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 24 24"
        width="20"
        height="20"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {paths}
      </svg>
    </span>
  );
}
